import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ContactForm from './pages/ContactForm';
import About from './pages/About';
import Blog from './pages/Blog';
import Home from './pages/Home';
import Careers from './pages/Careers';
import Services from './pages/Services';
import BlogDetails from './pages/BlogDetails';

function App() {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Home/>} />
        <Route path="/contact-us" element={<ContactForm />} />
        <Route path="/about" element={<About/>} />
        <Route path="/blog" element={<Blog/>} />
        <Route path="/blogdetails" element={<BlogDetails/>} />
        <Route path="/careers" element={<Careers/>} />
        <Route path="/services" element={<Services/>} />
      </Routes>
    </Router>
  )
}

export default App